import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Table from '../Common/Table';
import { consigneesAPI, inventoryTransfersAPI } from '../../services/api';

const InventoryTransfersManagement = () => {
  const [transfers, setTransfers] = useState([]);
  const [consignees, setConsignees] = useState([]);
  const [fromConsigneeId, setFromConsigneeId] = useState('');
  const [toConsigneeId, setToConsigneeId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const columns = useMemo(() => ([
    { key: 'id', label: 'ID' },
    {
      key: 'created_at',
      label: 'Created',
      format: (v) => (v ? new Date(v).toLocaleString() : '-'),
    },
    { key: 'from_consignee_name', label: 'From Consignee' },
    { key: 'to_consignee_name', label: 'To Consignee' },
    { key: 'quantity', label: 'Qty' },
    { key: 'from_inventory_items_id', label: 'From Item ID' },
    { key: 'to_inventory_items_id', label: 'To Item ID' },
    { key: 'performed_by_username', label: 'Performed By' },
  ]), []);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const [consigneesData, transfersData] = await Promise.all([
        consigneesAPI.getAll(),
        inventoryTransfersAPI.getAll({
          ...(fromConsigneeId ? { from_consignee_id: fromConsigneeId } : {}),
          ...(toConsigneeId ? { to_consignee_id: toConsigneeId } : {}),
          limit: 500,
        }),
      ]);
      setConsignees(consigneesData || []);
      setTransfers(transfersData || []);
    } catch (e) {
      setError(e.message || 'Failed to load transfers');
    } finally {
      setLoading(false);
    }
  }, [fromConsigneeId, toConsigneeId]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="management-page">
      <div className="page-header">
        <h2>Inventory Transfers (Audit)</h2>
      </div>

      <div className="filters">
        <select value={fromConsigneeId} onChange={(e) => setFromConsigneeId(e.target.value)}>
          <option value="">All From Consignees</option>
          {consignees.map((c) => (
            <option key={c.id} value={c.id}>
              {c.company_name}
            </option>
          ))}
        </select>

        <select value={toConsigneeId} onChange={(e) => setToConsigneeId(e.target.value)}>
          <option value="">All To Consignees</option>
          {consignees.map((c) => (
            <option key={c.id} value={c.id}>
              {c.company_name}
            </option>
          ))}
        </select>

        <button className="btn-primary" onClick={load} disabled={loading}>
          Refresh
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}
      {loading ? <div className="loading">Loading...</div> : <Table data={transfers} columns={columns} />}
    </div>
  );
};

export default InventoryTransfersManagement;

